/* eslint-disable react/destructuring-assignment */
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { AddUserInput, useUpdateUserProjectMutation } from '../../../../../graphql/generated/graphql';
import { setAlertDescription } from '../../../../hooks/actions';
import ContactsForm from '../Form';
import { useProjectsState } from '../../../../hooks/projectsInfo';

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60%',
  maxWidth: 500,
  bgcolor: '#fff',
  boxShadow: 24,
  borderRadius: '20px',
  p: 4,
};

const ContactsModal = (props: any) => {
  const { item } = props;
  const [open, setOpen] = useState(false);
  const currentProject = useProjectsState().projectId.get() || '';
  const handleOpen = () => setOpen(true);
  const [updateLocation] = useUpdateUserProjectMutation();

  const handleClose = () => {
    props.close();
    setOpen(false);
  };
  const [loading, setLoading] = useState<boolean>(false)

  const onSaveInfoContact = async (data: AddUserInput) => {
    try {
      setLoading(true);
      await updateLocation({
        variables: {
          project_id: currentProject,
          users: [data],
        },
      }).then(() => {
        setLoading(false)
        setAlertDescription({
          open: true,
          message: 'The Job Title has been updated succesfully',
          severity: 'success',
        })
      });
      handleClose();
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (props?.open) {
      handleOpen();
    }
  }, [props?.open]);

  return (
    <>
      <Modal
        open={open}
        onClose={() => handleClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ContactsForm
            handleSubmit={onSaveInfoContact}
            item={item}
            loading={loading}
          />
        </Box>
      </Modal>
    </>
  );
}
export default ContactsModal;
